import LinkNoMessageHelp1 from "@/assets/images/link_noMessage_help_1.png";
import LinkNoMessageHelp2 from "@/assets/images/link_noMessage_help_2.png";
import LinkNoMessageHelp3 from "@/assets/images/link_noMessage_help_3.png";
import LinkNoMessageHelp4 from "@/assets/images/link_noMessage_help_4.png";
import LinkNoMessageHelp5 from "@/assets/images/link_noMessage_help_5.png";

export default function LinkNoMessageHelp() {
  return (
    <div className="px-6.5">
      <div className="text-4 mb-2 text-mx-secondary font-500 lh-6">
        1. 点击左下麦克风icon，切换至合适的拾音设备
      </div>
      <img src={LinkNoMessageHelp1} className="w-full mb-8" />
      <div className="text-4 mb-2 text-mx-secondary font-500 lh-6">
        2. 未开启系统对AI会记应用的麦克风权限
      </div>
      <div className="text-3.5 mb-2 text-#30343C font-500 lh-5.5">Macbook 电脑</div>
      <div className="text-3.5 mb-2 text-#30343C font-400 lh-5.5">
        打开「系统偏好设置」，选择「安全性与隐私」➡️
        点击页面上方「隐私」tab目录➡
        在左侧栏选择「麦克风」，勾选MAXHUB会记，开启麦克风权限
      </div>
      <img src={LinkNoMessageHelp2} className="w-full mb-8" />
      <div className="text-3.5 mb-2 text-#30343C font-500 lh-5.5">Windows 电脑</div>
      <div className="text-3.5 mb-2 text-#30343C font-400 lh-5.5">
        打开「设置」，选择「隐私」➡️
        在左侧打开应用权限中的「麦克风」选项，在「允许桌面应用访问你的麦克风」中选择开启
      </div>
      <img src={LinkNoMessageHelp3} className="w-full mb-8" />
      <div className="text-4 mb-2 text-mx-secondary font-500 lh-6">
        3. 查看声音输入设备是否正常
      </div>
      <div className="text-3.5 mb-2 text-#30343C font-500 lh-5.5">Macbook 电脑</div>
      <div className="text-3.5 mb-2 text-#30343C font-400 lh-5.5">
        打开「系统偏好设置」，选择「声音」➡️
        选择「输入」，测试当前输入设备是否可用
      </div>
      <img src={LinkNoMessageHelp4} className="w-full mb-8" />
      <div className="text-3.5 mb-2 text-#30343C font-500 lh-5.5">Windows 电脑</div>
      <div className="text-3.5 mb-2 text-#30343C font-400 lh-5.5">
        打开「设置」，选择「隐私」➡️
        在左侧打开应用权限中的「麦克风」选项，在「允许桌面应用访问你的麦克风」中选择开启
      </div>
      <img src={LinkNoMessageHelp5} className="w-full mb-8" />
    </div>
  );
}
